module.exports = __webpack_public_path__ + "img/Partners 6.729ec25c.png";